function customGetComparedProducts() {
    return JSON.parse(localStorage.getItem('customComparedProducts') || '[]');
}

function customSaveComparedProducts(products) {
    localStorage.setItem('customComparedProducts', JSON.stringify(products));
}

function customAddToCompare(product, $button) {
    const products = customGetComparedProducts();
    const isAlreadyAdded = products.some(p => p.variant_id === product.variant_id);
    if (isAlreadyAdded) {
        customToggleComparePopup();
        return;
    }
    if (products.length >= 5) {
        $('#custom-compare-popup').show();
        customShowToast(window.customCompareTranslations.limitMessage);
        return;
    }

    products.push(product);
    customSaveComparedProducts(products);
    customRenderComparePopup();
    if ($button) {
        $button.find('.compare-button-text').text(window.customCompareTranslations.added);
        $button.addClass('custom-added');
    }
}

function customRemoveFromCompare(variantId) {
    let products = customGetComparedProducts();
    products = products.filter(p => String(p.variant_id) !== String(variantId));
    customSaveComparedProducts(products);
    customRenderComparePopup();
    customUpdateButtons();
}

function customClearCompare() {
    localStorage.removeItem('customComparedProducts');
    customRenderComparePopup();
    customUpdateButtons();
}

function customRenderComparePopup() {
    const products = customGetComparedProducts();
    if (products.length == 0) {
        $('.custom-empty-popup').addClass('custom-back-btn')
        $('.custom-compare-scroll').addClass('custom-hide-table');
        $(document).on('click', '#back-to-shop', function () {
            let collectionUrl = '/collections/all';
 
            if (Shopify.locale && Shopify.locale !== 'de') {
                collectionUrl = '/' + Shopify.locale + '/collections/all';
            }
 
            window.location.href = collectionUrl;
        });
    } else {
        $('.custom-empty-popup').removeClass('custom-back-btn');
        $('.custom-compare-scroll').removeClass('custom-hide-table');
    }
    const $table = $('.custom-compare-table');
    const $removeRow = $('#custom-remove-row');
    const $tbody = $table.find('tbody');
    const $input = $('#custom-compare-added-btn-txt');
    const addToCartText = $input.data('add-to-cart-txt');
    const soldOutText = $input.data('sold-out-txt');

    // Reset table
    $removeRow.html('<th></th>');
    $tbody.find('tr').each(function () {
        const rowTitle = $(this).find('th').text();
        $(this).html(`<th>${rowTitle}</th>`);
    });

    $.each(products, function (index, p) {
        let handle;
        $removeRow.append(`<th><button class="custom-remove-button" data-id="${p.variant_id}">×</button></th>`);
        $tbody.find('tr:eq(0)').append(`<td><img src="${p.image || 'https://via.placeholder.com/80'}" alt="${p.title}" style="max-width:150px;"></td>`);
        $tbody.find('tr:eq(1)').append(`<td class="custom-product-title-${index}"><a href="${window.Shopify.routes.root}products/${handle}">${window.customTranslations.loading}</a></td>`);
        handle = p.handle;
            fetch(window.Shopify.routes.root + 'products/'+ handle + '.js')
            .then(response => response.json())
            .then(product => { 
                $(`.custom-product-title-${index}`).html(`<a href="${window.Shopify.routes.root}products/${handle}">${product.title}</a>`);
            })
            .catch(error => {
                console.error("Error fetching product:", error);
            });
        
        $tbody.find('tr:eq(2)').append(`<td>${p.price}</td>`);
        $tbody.find('tr:eq(3)').append(`
        <td>
        <product-form>
             <form method="post" action="/cart/add">
            <input type="hidden" name="id" value="${p.variant_id}" />
            <button type="submit" class="product-form__submit button button--primary" ${!p.isAvailable ? 'disabled' : ''}><span>${p.isAvailable ? addToCartText : soldOutText} </span> <span class="loading-overlay__spinner hidden">
              <svg
                aria-hidden="true"
                focusable="false"
                class="spinner"
                viewBox="0 0 66 66"
                xmlns="http://www.w3.org/2000/svg"
              >
                <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>
              </svg>
            </span></button>
          </form>
          </product-form>
        </td>`);
    });

    return products;
}
function customToggleComparePopup() {
    $('#custom-compare-popup').toggle();
}

function customUpdateButtons() {
    const products = customGetComparedProducts();
    $('.custom-compare-button').each(function () {
        const $btn = $(this);
        const variantId = String($btn.attr('data-variant-id'));
        const isAdded = products.some(p => String(p.variant_id) === variantId);
        const defaultBtnText = $btn.attr('data-btn-text') || 'Compare';
        const addedBtnText = $('#custom-compare-added-btn-txt').val() || 'Added';

        if (isAdded) {
            $btn.find('.compare-button-text').text(addedBtnText);
            $btn.addClass('custom-added');
        } else {
            $btn.find('.compare-button-text').text(defaultBtnText);
            $btn.removeClass('custom-added');
        }
    });
}

$(document).ready(function () {
    // Initial setup
    customRenderComparePopup();
    customUpdateButtons();

    // Compare button click
    $(document).on('click', '.custom-compare-button', function () {
        const $btn = $(this);
        const productInfoNode = $btn.closest('product-info')[0];
        const selectedVariantJSON = productInfoNode?.querySelector('[data-selected-variant]')?.innerHTML;
        let product;
        if (selectedVariantJSON) {
            const variant = JSON.parse(selectedVariantJSON);
            const baseTitle = $btn.data('title').split(' - ')[0];
            const variantTitle = variant.public_title || variant.title || '';
            const fullTitle = `${baseTitle} - ${variantTitle}`;
            const originalUrl = $btn.data('url') || '';
            const productHandle = $btn.data('handle') || '';
            const updatedUrl = originalUrl.includes('?variant=')
                ? originalUrl.replace(/variant=\d+/, `variant=${variant.id}`)
                : `${originalUrl}?variant=${variant.id}`;
            const currency = Shopify?.currency?.active || '';
            const amount = (variant.price / 100).toFixed(2);
            const formattedPrice = `${currency} ${amount}`;
            product = {
                id: $btn.data('product-id'),
                variant_id: variant.id,
                title: fullTitle,
                price: formattedPrice,
                image: variant?.featured_image?.src,
                url: updatedUrl,
                handle: productHandle,
                isAvailable: variant?.available
            };
        } else {
            product = {
                id: $btn.data('product-id'),
                variant_id: $btn.data('variant-id'),
                title: $btn.data('title'),
                price: $btn.data('price'),
                image: $btn.data('image'),
                url: $btn.data('url'),
                handle: $btn.data('handle'),
                isAvailable: $btn.data('is-available')
            };
        }

        const isAdded = $btn.hasClass('custom-added');
        if (isAdded) {
            customToggleComparePopup();
        } else {
            customAddToCompare(product, $btn);
        }
        $('#custom-compare-popup').show();
    });

    // Remove product from compare
    $(document).on('click', '.custom-remove-button', function () {
        const variantId = $(this).data('id');
        customRemoveFromCompare(variantId);
    });

    // Clear all compare
    $(document).on('click', '.custom-clear-button', function () {
        customClearCompare();
    });

    // Popup close
    $(document).on('click', '.custom-close-compare', function () {
        $('#custom-compare-popup').hide();
    });

    const observer = new MutationObserver(function (mutations, obs) {
        const $recommendations = $('.product-recommendations--loaded');
        if ($recommendations.length) {
            customUpdateButtons();
            obs.disconnect();
        }
    });
    observer.observe(document.body, {
        childList: true,
        subtree: true
    });
});
function customShowToast(message) {
    let $toast = $('#custom-toast-message');
    if (!$toast.length) {
        $toast = $('<div id="custom-toast-message"></div>').appendTo('body');
        $toast.css({
            position: 'fixed',
            top: '20px',
            left: '50%',
            transform: 'translateX(-50%)',
            background: '#333',
            color: '#fff',
            padding: '12px 20px',
            'border-radius': '8px',
            'z-index': 100000,
            display: 'none',
            'font-size': '14px'
        });
    }

    $toast.text(message).fadeIn(300);

    setTimeout(() => {
        $toast.fadeOut(400);
    }, 3000);
}
